import React from "react";

export function highlightTitle(
  text: string,
  title: string,
  color: string
): React.ReactNode {
  if (!title || !text.includes(title)) {
    return text;
  }

  const parts = text.split(title);

  return parts.reduce(
    (acc: React.ReactNode[], part: string, index: number) => {
      if (index === parts.length - 1) {
        return [...acc, part];
      }
      return [
        ...acc,
        part,
        React.createElement(
          "strong",
          {
            key: index,
            style: { color }, // 👈 dynamic color applied
            className: "strongP", // keep class if you also want common styles
          },
          title
        ),
      ];
    },
    []
  );
}
